<div class="register-page">
  <div class="register-card">
    <h2 class="register-title">Registration</h2>
    <p class="register-subtitle">Complete your account registration to submit a COLOCATION application.</p>

    @if (errorMessage()) {
      <vb-alert type="error" variant="soft" [showIcon]="true" [message]="errorMessage()!" class="block mb-4" />
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="register-grid">
        <div class="register-col">
          <vb-input id="firstName" label="First Name" [required]="true" formControlName="firstName" />
          <vb-input id="lastName" label="Last Name" [required]="true" formControlName="lastName" />
          <vb-input id="title" label="Title" [required]="true" formControlName="title" />
          <vb-input id="company" label="Company" [required]="true" formControlName="company" />
          <vb-input id="address1" label="Street Address" [required]="true" formControlName="address1" />
          <vb-input id="address2" label="Street Address 2" formControlName="address2" />
        </div>
        <div class="register-col">
          <vb-input id="city" label="City" [required]="true" formControlName="city" />
          <vb-select
            id="state"
            label="State"
            placeholder="Select an option"
            [required]="true"
            [customDropdown]="true"
            [options]="states"
            formControlName="state"
          />
          <vb-input id="postalCode" label="Postal Code" placeholder="12345 or 12345-6789" [required]="true" formControlName="postalCode" />
          <vb-input id="phoneNumber" label="Phone Number" type="tel" placeholder="(555) 555-5555" [required]="true" formControlName="phoneNumber" />
          <vb-select
            id="describesAffiliationWithVB"
            label="Which option best describes your affiliation with Vertical Bridge?"
            placeholder="Select an option"
            [required]="true"
            [customDropdown]="true"
            [options]="affiliations"
            formControlName="describesAffiliationWithVB"
          />
          <vb-select
            id="describesRoleInCompany"
            label="Which option best describes your role within a company?"
            placeholder="Select an option"
            [required]="true"
            [customDropdown]="true"
            [options]="roles"
            formControlName="describesRoleInCompany"
          />
        </div>
      </div>

      <div class="register-terms">
        <h4 class="register-terms-title">Acceptance of Terms<span class="text-error">*</span></h4>
        <div class="register-terms-row">
          <vb-checkbox formControlName="iAgree" label="I Agree" />
          <p class="register-terms-body">
            This Website is owned and operated by and on behalf of Vertical Bridge and/or its wholly owned affiliates
            and subsidiaries (collectively "VB") and is made available to you, subject to these terms of use, for
            information, education and communication purposes only. By accessing one or more areas of this web site
            you are agreeing to be bound by these terms of use, and all applicable federal, state, and local laws and
            regulations. If you do not agree with these terms promptly exit this web site. Any claim relating to the use
            of this web site is governed by the laws of the state of Florida in the United States.
          </p>
        </div>
      </div>

      <div class="register-actions">
        <vb-button type="button" variant="outline" (click)="onCancel()">Cancel</vb-button>
        <vb-button type="submit" variant="primary" [disabled]="!canSubmit()" [loading]="isSaving()">
          @if (isSaving()) { Saving... } @else { Continue }
        </vb-button>
      </div>
    </form>
  </div>
</div>
